import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';
import { StoreType } from './useGetStoresList';
import { RoleCode } from './useGetRoles';

export type UserDetails = {
  id: number;
  email: string;
  activated: false;
  created_at: string;
  is_active: false;
  name: null | string;
  phone_number: null | string;
  role_id: number;
  role_code: RoleCode;
  stores: StoreType[];
  updated_at: string;
  franchise_owner_id: null | number;
};

export type UserDetailsResponseType = UserDetails;

export const useGetUserDetail = (
  id?: string,
  options: QueryOptions<UserDetailsResponseType, AxiosError<ApiError>> = {}
) => {
  return useQuery({
    queryFn: async (): Promise<UserDetailsResponseType> => {
      const { data } = await api.get<ApiResponse<UserDetailsResponseType>>(
        `/user/${id}`
      );

      return data.data;
    },
    queryKey: ['user', id],
    enabled: !!id,
    ...options,
  });
};
